import React from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Chip, Input, Button, FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as lang from '../../../../Constants/strings';
import BlockRoundedIcon from '@material-ui/icons/BlockRounded';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';

const useStyles = makeStyles(theme => ({
    chip: {
        margin: 2,
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
}));

export default function SiteTypeEditForm(props) {
    const classes = useStyles();
    const { editData, language, active, updateField } = props;

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    disabled={!active}
                    required
                    fullWidth
                    variant="outlined"
                    name="SITE_TYPE"
                    label={lang.SITE_TYPE[language]}
                    value={editData.SITE_TYPE ? editData.SITE_TYPE : ""}
                    onChange={(e) => updateField(e, 150)}
                />
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    color={active ? "secondary" : "primary"}
                    onClick={() => { props.toggleExecutor(); props.close(); }}
                >
                    {active ?
                        <BlockRoundedIcon fontSize="small" className={classes.leftIcon} />
                        :
                        <CheckCircleOutlineRoundedIcon fontSize="small" className={classes.leftIcon} />
                    }
                    {lang.TOGGLE_ACTION(active)[language]}
                </Button>
            </Grid>
        </Grid>
    );
}